import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../context/AuthContext';
import { useOrg } from '../context/OrgContext';

// Was a Bootstrap .spinner-border, which stopped rendering anything once bootstrap.min.css
// was dropped from App.tsx.
const Spinner = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
    <Spin size="large" />
  </div>
);

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, isLoading: authLoading } = useAuth();
  const { userProfile, isLoading: orgLoading } = useOrg();
  const { pathname } = useLocation();

  if (authLoading || orgLoading) return <Spinner />;
  if (!currentUser) return <Navigate to="/login" replace />;

  // New users without an org need to set one up (unless they're already on /setup or /team)
  if (userProfile && !userProfile.orgId && pathname !== '/setup' && pathname !== '/team') {
    return <Navigate to="/setup" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
